import {Injectable} from "@angular/core";
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

/**
 * @desc Erlaubt direkte Navigation zur Fehlerseite nur, wenn es sich um internen Fehelr handelt, so dass Nutzer nicht direkt auf Error-Seite navigieren kann.
 */
@Injectable()
export class ErrorGuard implements CanActivate
{


	/**
	 * Function > constructor
	 * @param OBJ_router
	 */
	constructor(private OBJ_router: Router) {} // end function constructor


	/**
	 * Function > canActivate
	 * @param OBJ_route
	 * @param OBJ_state
	 * @return {boolean}
	 */
	canActivate(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): boolean
	{

		if (localStorage.getItem("internal"))
		{
			// remove marker from local storage
            localStorage.removeItem("internal");

			// internal Navigation, return true
			return true;
		} // end if

		// user tries to call errorpage directly - redirect to starter page
		this.OBJ_router.navigate(["/starter"]);
		return false;

	} // end function canActivate


} // end function AuthGuard